import { GET_USER_DETAILS_REQUEST } from './types';

export function getUserDetails() {
  return {
    type: GET_USER_DETAILS_REQUEST,
    payload: {},
  };
}
